/* ARGMAC — shared features: grouped mega-menu, search overlay, cart drawer (GST + pincode),
   lightbox zoom, wishlist, recently viewed, concierge, will-it-fit. Vanilla JS. */
(function () {
  "use strict";
  var ROOT = "";
  // Outside India: no GST rows, no India-only perks (DEC-044 storefronts; prices exclude local taxes & duties).
  function isIntl() { var m = document.body && document.body.dataset.market; return !!m && m !== "IN"; }
  var INTL_NOTE = '<div class="cart-perk">Excl. taxes &amp; duties · Shipping &amp; installation not included</div>';
  var CDN = "https://cdn.shopify.com/s/files/1/0559/6417/2484/files/";

  /* ---------------- MEGA MENU (grouped columns) ---------------- */
  var MEGA = {
    "gaming": {
      img: CDN + "Web_upload_pictures_size_9e4d6c83-b4c7-4db6-a590-429eb6c85d86.jpg?v=1779694441",
      imgHref: "collections/gaming-tables",
      cols: [
        ["Billiards", [
          ["Pool Tables", "collections/pool-tables"],
          ["Snooker Tables", "collections/snooker-tables"],
          ["Cue Stands & Accessories", "collections/pool-accessories"]]],
        ["The Game Room", [
          ["Table Tennis", "collections/table-tennis-tables"],
          ["Air Hockey", "collections/air-hockey-tables"],
          ["Carrom Tables", "collections/carrom-tables"],
          ["Foosball Tables", "collections/foosball-tables"],
          ["Chess Tables", "collections/chess-table"],
          ["DJ Tables", "collections/dj-tables"]]]
      ],
      all: ["View all gaming tables", "collections/gaming-tables"]
    },
    "bar": {
      img: CDN + "8T.jpg?v=1747905171?v=1779433206",
      imgHref: "collections/bar",
      cols: [
        ["The Bar Collection", [
          ["Home Bars", "collections/homebars"],
          ["Bar Cabinets", "collections/bar-cabinets"],
          ["Bar Counters", "collections/bar-counters"],
          ["Bar Stools", "collections/bar-stools"]]],
        ["The Service", [
          ["Book a Consultation", "pages/consultation"],
          ["Order Finish Swatches", "pages/swatches"],
          ["The Craft", "pages/craft"]]]
      ],
      all: ["View the complete bar collection", "collections/bar"]
    },
    "bestsellers": {
            img: CDN + "bestseller-menu-pool-table_jpg.webp?v=1791540722",
      imgHref: "collections/bestsellers",
      cols: [
        ["Most Commissioned", [
          ["Negroni Pool Table", "products/negroni-pool-table"],
          ["Kingston Pool Table", "products/kingston-pool-table"],
          ["Harveys Home Bar", "products/harveys-luxury-home-bar"],
          ["Stoner — Marble", "products/stoner-pool-table"]]],
        ["The House", [
          ["The Craft", "pages/craft"],
          ["Journal", "pages/journal"],
          ["Gallery", "pages/gallery"]]]
      ],
      all: ["View all bestsellers", "collections/bestsellers"]
    }
  };

  function buildMega() {
    var header = document.querySelector(".header");
    var nav = document.querySelector(".header .nav");
    if (!header || !nav || window.innerWidth <= 1020) return;
    var panel = document.createElement("div");
    panel.className = "mega";
    header.appendChild(panel);
    var hideT;
    function show(key) {
      var d = MEGA[key];
      if (!d) return;
      clearTimeout(hideT);
      var cols = d.cols.map(function (c) {
        return "<div><h5>" + c[0] + "</h5><ul>" + c[1].map(function (l) {
          return '<li><a href="' + ROOT + "/" + l[1] + '">' + l[0] + "</a></li>";
        }).join("") + "</ul></div>";
      }).join("");
      panel.innerHTML =
        '<div class="mega-inner">' +
        '<a class="mega-img" href="' + ROOT + "/" + d.imgHref + '"><img src="' + d.img + '" alt=""></a>' +
        cols +
        '<div class="mega-foot"><a class="mega-all" href="' + ROOT + "/" + d.all[1] + '">' + d.all[0] + "</a></div></div>";
      panel.classList.add("open");
    }
    function hide() { hideT = setTimeout(function () { panel.classList.remove("open"); }, 180); }
    nav.querySelectorAll("a").forEach(function (a) {
      var key = a.dataset.mega;
      if (!key || !MEGA[key]) { a.addEventListener("mouseenter", hide); return; }
      a.addEventListener("mouseenter", function () { show(key); });
    });
    nav.addEventListener("mouseleave", hide);
    panel.addEventListener("mouseenter", function () { clearTimeout(hideT); });
    panel.addEventListener("mouseleave", hide);
  }

  /* ---------------- MOBILE NAV — CATEGORY ACCORDION ---------------- */
  /* Turns each Shop row in the mobile drawer into a tap-to-expand accordion
     carrying the same sub-categories as the desktop mega menu. */
  function buildMobileMega() {
    var nav = document.getElementById("mobileNav");
    if (!nav) return;
    var rows = nav.querySelectorAll(".mn-item[data-mega]");
    if (!rows.length) return;

    function shut() { nav.classList.remove("open"); document.body.style.overflow = ""; }

    Array.prototype.forEach.call(rows, function (a) {
      var d = MEGA[a.dataset.mega];
      if (!d) return;
      var label = (a.textContent || "").trim();
      var thumb = a.querySelector(".mn-thumb");

      var row = document.createElement("button");
      row.type = "button";
      row.className = "mn-item mn-toggle";
      row.setAttribute("aria-expanded", "false");
      row.innerHTML = (thumb ? thumb.outerHTML : "") +
        '<span class="mn-label">' + label + "</span>" +
        '<span class="mn-chev" aria-hidden="true"></span>';

      var inner = "";
      d.cols.forEach(function (c) {
        inner += '<span class="mn-subgroup">' + c[0] + "</span>";
        c[1].forEach(function (l) {
          inner += '<a href="' + ROOT + "/" + l[1] + '">' + l[0] + "</a>";
        });
      });
      inner += '<a class="mn-all" href="' + ROOT + "/" + d.all[1] + '">' + d.all[0] + "</a>";

      var sub = document.createElement("div");
      sub.className = "mn-sub";
      sub.innerHTML = '<div class="mn-sub-in">' + inner + "</div>";

      a.parentNode.insertBefore(row, a);
      a.parentNode.insertBefore(sub, a);
      a.parentNode.removeChild(a);

      row.addEventListener("click", function () {
        var wasOpen = sub.classList.contains("open");
        Array.prototype.forEach.call(nav.querySelectorAll(".mn-sub.open"), function (s) {
          s.classList.remove("open"); s.style.maxHeight = "";
        });
        Array.prototype.forEach.call(nav.querySelectorAll(".mn-toggle.on"), function (t) {
          t.classList.remove("on"); t.setAttribute("aria-expanded", "false");
        });
        if (!wasOpen) {
          sub.classList.add("open");
          sub.style.maxHeight = (sub.querySelector(".mn-sub-in").scrollHeight + 20) + "px";
          row.classList.add("on");
          row.setAttribute("aria-expanded", "true");
          setTimeout(function () {
            if (row.getBoundingClientRect().top < 90) return;
            row.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }, 480);
        }
      });

      Array.prototype.forEach.call(sub.querySelectorAll("a"), function (l) {
        l.addEventListener("click", shut);
      });
    });
  }

  /* ---------------- SEARCH OVERLAY (Shopify Predictive Search) ---------------- */
  function buildSearch() {
    var triggers = document.querySelectorAll(".search-open");
    if (!triggers.length) return;

    var ov = document.createElement("div");
    ov.className = "srch";
    ov.innerHTML =
      '<div class="srch-inner">' +
      '<div class="srch-top">' +
      '<span class="srch-kicker">Search the House</span>' +
      '<button class="srch-close" type="button" aria-label="Close search">Close</button>' +
      '</div>' +
      '<div class="srch-field">' +
      '<input class="srch-input" type="text" placeholder="Search for:" aria-label="Search" autocomplete="off" spellcheck="false">' +
      '</div>' +
      '<div class="srch-trending"><span class="srch-tlabel">Trending Searches</span><span class="srch-tlinks"></span></div>' +
      '<div class="srch-body">' +
      '<aside class="srch-rail"></aside>' +
      '<div class="srch-main" aria-live="polite"></div>' +
      '</div></div>';
    document.body.appendChild(ov);

    var input = ov.querySelector(".srch-input");
    var main = ov.querySelector(".srch-main");
    var rail = ov.querySelector(".srch-rail");
    var tlinks = ov.querySelector(".srch-tlinks");

    var RECENT_KEY = "argmac_recent_searches";
    var RROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var swatch = (window.ARGMAC_CFG && window.ARGMAC_CFG.swatch) || {};

    var TRENDING = [
      { label: "Pool Tables", q: "pool" },
      { label: "Home Bars", q: "home bar" },
      { label: "Snooker", q: "snooker" },
      { label: "Stone Series", q: "stone" },
      { label: "Bar Cabinets", q: "bar cabinet" }
    ];
    var SHOP = [
      { label: "Gaming Tables", href: "/collections/gaming-tables" },
      { label: "Bar", href: "/collections/bar" },
      { label: "Bestsellers", href: "/collections/bestsellers" }
    ];
    var DISCOVER = [
      { label: "Book a Consultation", href: "/pages/consultation" },
      { label: "The Gallery", href: "/pages/gallery" }
    ];
    var SYN = [
      ["ping pong", "table tennis"], ["ping-pong", "table tennis"], ["pingpong", "table tennis"],
      ["table-tennis", "table tennis"], ["tt", "table tennis"],
      ["billiards", "pool"], ["billiard", "pool"],
      ["snooker board", "snooker"],
      ["bar counter", "bar"],
      ["marble", "stone"],
      ["cues", "accessories"], ["cue", "accessories"],
      ["fussball", "foosball"], ["fooseball", "foosball"]
    ];
    var BASE_COLOURS = ["beige", "green", "navy", "brown", "burgundy", "plum", "red", "olive",
      "gray", "grey", "blue", "charcoal", "white", "mahogany", "walnut", "black", "gold", "orange", "silver", "cream"];

    var MAT_SYN = {
      "synthetic leather": "leather", "hand-finished leather": "leather", "leatherette": "leather", "leather": "leather",
      "pu paint": "pu", "pu matt": "pu", "pu satin": "pu", "pu gloss": "pu", "polyurethane": "pu", "lacquer": "pu", "paint": "pu", "matt": "pu", "matte": "pu", "gloss": "pu", "high-gloss": "pu", "satin": "pu", "pu": "pu",
      "wood veneer": "veneer", "top veneer": "veneer", "veneers": "veneer", "veneer": "veneer",
      "solid wood": "wood", "engineered wood": "wood", "wooden": "wood", "timber": "wood", "wood": "wood",
      "light oak": "oak", "dark oak": "oak", "black oak": "oak", "oak": "oak",
      "dark walnut": "walnut", "walnut": "walnut", "mahogany": "mahogany", "black teak": "teak", "teak": "teak", "ebony": "ebony",
      "white marble": "stone", "black marble": "stone", "marble": "stone", "travertine": "stone", "travertino": "stone",
      "rosso levanto": "stone", "italian marble": "stone", "patagonia stone": "stone", "stone": "stone",
      "laminate": "laminate", "mirror": "mirror",
      "powder coated": "metal", "powder-coated": "metal", "metallic": "metal", "brass": "metal", "steel": "metal", "metal": "metal",
      "playing cloth": "cloth", "felt": "cloth", "cloth": "cloth", "suede": "suede", "slate": "slate"
    };
    var MAT_PHRASES = Object.keys(MAT_SYN).sort(function (a, b) { return b.length - a.length; });
    var MAT_DISPLAY = { leather: "Leather", pu: "PU", veneer: "Veneer", wood: "Wood", oak: "Oak", walnut: "Walnut", mahogany: "Mahogany", teak: "Teak", ebony: "Ebony", stone: "Stone", laminate: "Laminate", mirror: "Mirror", metal: "Metal", cloth: "Cloth", suede: "Suede", slate: "Slate" };
    var CAT_CUSTOM = {
      "Pool Tables": ["pu", "veneer", "cloth", "leather", "stone", "laminate", "suede", "metal"],
      "Snooker Tables": ["cloth", "veneer", "wood", "pu", "slate"],
      "Home Bars": ["stone", "pu", "laminate", "mirror", "metal", "veneer", "leather", "wood"],
      "Bars & Cabinets": ["wood", "veneer", "pu", "metal", "stone", "laminate", "leather"],
      "Table Tennis": ["stone", "wood", "metal", "pu"],
      "Air Hockey": ["wood", "pu"], "Carrom Tables": ["wood", "pu"], "Chess Tables": ["wood", "pu", "stone"],
      "DJ Tables": ["wood", "pu"], "Foosball Tables": ["wood", "pu"], "Accessories": ["wood", "pu"]
    };
    var WOOD_SUB = { oak: 1, walnut: 1, mahogany: 1, teak: 1 };
    var MADE = {
      "stoner-pool-table": ["stone"], "travertino-pool-table": ["stone"], "rosso-levanto-pool-table": ["stone"],
      "caribbean-pool-table": ["mahogany", "leather", "wood"], "negroni-pool-table": ["leather"],
      "pietra-oro-tennis-table": ["stone"], "angostura-tennis-table": ["stone"], "candore-table-tennis": ["stone"], "veltrano-tennis-table": ["stone"],
      "takamaka-table-tennis-tables": ["walnut", "wood"],
      "archeon-home-bar": ["stone"], "sierra-bar-counter": ["stone", "wood"], "aurum-arc-home-bar": ["wood"], "baron-bar": ["wood"], "cantico-bar-cabinet": ["metal"],
      "mimosno-snooker-table": ["slate"], "negrosno-snooker-table": ["slate"],
      "takamaka-air-hockey": ["ebony", "wood"], "flamboyant-air-hockey": ["ebony", "wood"], "embargo-air-hockey-table": ["ebony", "wood"],
      "vindsor-air-hockey-table": ["ebony", "wood"], "mimosa-air-hockey-table": ["ebony", "wood"], "negroni-air-hockey-table": ["ebony", "wood"],
      "angostura-air-hockey-table": ["ebony", "wood"], "candore-air-hockey-table": ["ebony", "wood"], "outlier-air-hockey": ["wood"]
    };

    var rawQuery = "", colourNote = "", trendingCache = null;
    var items = [], hi = -1, reqSeq = 0, debT = null;

    /* ---- helpers ---- */
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }
    function titleCase(s) { return String(s).replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }
    function reEsc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }
    function money(v) { var n = parseFloat(String(v == null ? "" : v).replace(/[^0-9.]/g, "")); return isFinite(n) ? inr(n) : ""; }

    function normalize(q) {
      var s = " " + q.toLowerCase().replace(/\s+/g, " ").trim() + " ";
      SYN.forEach(function (p) {
        s = s.replace(new RegExp("(?:^|\\s)" + reEsc(p[0]) + "(?=\\s|$)", "g"), " " + p[1]);
      });
      return s.replace(/\s+/g, " ").trim();
    }
    function extractColour(q) {
      var toks = q.split(/\s+/).filter(Boolean), found = [], keep = [];
      toks.forEach(function (t) { (BASE_COLOURS.indexOf(t) !== -1 ? found : keep).push(t); });
      if (!found.length) return { stripped: q, note: "" };
      var names = [];
      Object.keys(swatch).forEach(function (k) {
        if (k === "default") return;
        for (var i = 0; i < found.length; i++) {
          if (k.indexOf(found[i]) !== -1) { names.push(titleCase(k)); break; }
        }
      });
      names = names.filter(function (v, i, a) { return a.indexOf(v) === i; });
      var note = names.length
        ? "Available in " + names.slice(0, 4).join(" / ")
        : "Available in " + found.map(titleCase).join(" / ");
      return { stripped: keep.join(" ").trim(), note: note };
    }

    function suggestURL(q, limit) {
      return RROOT + "search/suggest.json?q=" + encodeURIComponent(q) +
        "&resources[type]=product,collection,page" +
        "&resources[limit]=" + (limit || 8) +
        "&resources[options][unavailable_products]=hide";
    }
    function fetchSuggest(q, limit, cb) {
      fetch(suggestURL(q, limit), { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var res = j && j.resources && j.resources.results;
          if (!res) { cb(null); return; }
          cb({ products: res.products || [], collections: res.collections || [], pages: res.pages || [] });
        })
        .catch(function () { cb(null); });
    }

    function mapSuggest(p) {
      var img = p.image || (p.featured_image && p.featured_image.url) ||
        (p.featured_media && p.featured_media.preview_image && p.featured_media.preview_image.src) || "";
      var pr;
      if (p.price_varies && p.price_min != null) pr = "From " + money(p.price_min);
      else pr = money(p.price != null ? p.price : p.price_min);
      return { url: p.url, image: img, title: p.title || "", type: (p.type || p.product_type || ""), price: pr };
    }
    function mapCollectionJSON(p) {
      var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || p.featured_image || "";
      var v = (p.variants && p.variants[0]) || {};
      var pr = v.price != null ? money(v.price) : "";
      return { url: "/products/" + p.handle, image: img, title: p.title || "", type: (p.product_type || p.type || ""), price: pr };
    }
    function cardProduct(o) {
      return '<a class="srch-card" href="' + o.url + '">' +
        '<div class="sc-img"><img loading="lazy" src="' + o.image + '" alt="' + esc(o.title) + '"></div>' +
        "<h4>" + esc(o.title) + "</h4>" +
        "<span>" + (o.type ? esc(o.type) + " · " : "") + o.price + "</span></a>";
    }
    function linkCard(url, title) { return '<a class="srch-link" href="' + url + '"><span>' + esc(title) + "</span></a>"; }
    function skel(n) { var s = ""; for (var i = 0; i < n; i++) s += '<div class="srch-skel"></div>'; return s; }

    /* ---- static chrome (trending + rail) ---- */
    function fillTrending() {
      tlinks.innerHTML = TRENDING.map(function (t) {
        return '<button type="button" class="srch-tlink" data-q="' + esc(t.q) + '">' + esc(t.label) + "</button>";
      }).join("");
    }
    function navLink(o) { return '<a class="srch-navlink" href="' + o.href + '">' + esc(o.label) + "</a>"; }
    function buildRail() {
      var html = '<div class="srch-railgroup"><span class="srch-raillabel">Shop</span>' + SHOP.map(navLink).join("") + "</div>";
      html += '<div class="srch-railgroup"><span class="srch-raillabel">Discover</span>' + DISCOVER.map(navLink).join("") + "</div>";
      var rec = load(RECENT_KEY) || [];
      if (rec.length) {
        html += '<div class="srch-railgroup"><span class="srch-raillabel">Recent</span>' +
          rec.slice(0, 5).map(function (s) {
            return '<button type="button" class="srch-recentlink" data-q="' + esc(s) + '">' + esc(s) + "</button>";
          }).join("") + "</div>";
      }
      rail.innerHTML = html;
    }

    /* ---- states ---- */
    function showEmpty() {
      colourNote = "";
      buildRail();
      main.innerHTML = '<div class="srch-mhead"><span class="srch-mlabel">Most Coveted</span></div>' +
        '<div class="srch-cards" data-trend>' + skel(6) + "</div>";
      var slot = main.querySelector("[data-trend]");
      if (trendingCache) { if (slot) slot.innerHTML = trendingCache.map(cardProduct).join(""); collectItems(); }
      else loadTrending(slot);
      collectItems();
    }
    function loadTrending(slot) {
      fetch(RROOT + "collections/bestsellers/products.json?limit=6", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var arr = (j && j.products ? j.products.slice(0, 6) : []).map(mapCollectionJSON);
          if (arr.length) { trendingCache = arr; if (slot) slot.innerHTML = arr.map(cardProduct).join(""); collectItems(); return; }
          fetchSuggest("pool", 6, function (d) {
            var a2 = (d && d.products) ? d.products.slice(0, 6).map(mapSuggest) : [];
            trendingCache = a2; if (slot) slot.innerHTML = a2.map(cardProduct).join(""); collectItems();
          });
        })
        .catch(function () {
          fetchSuggest("pool", 6, function (d) {
            var a2 = (d && d.products) ? d.products.slice(0, 6).map(mapSuggest) : [];
            trendingCache = a2; if (slot) slot.innerHTML = a2.length ? a2.map(cardProduct).join("") : ""; collectItems();
          });
        });
    }
    function renderResults(data, noteText) {
      var html = "";
      var note = noteText || colourNote;
      if (note) html += '<div class="srch-note">' + esc(note) + "</div>";
      if (data.products.length) {
        html += '<div class="srch-mhead"><span class="srch-mlabel">Pieces</span>' +
          '<a class="srch-viewall" href="/search?q=' + encodeURIComponent(rawQuery) + '">View all &rarr;</a></div>' +
          '<div class="srch-cards">' + data.products.map(mapSuggest).map(cardProduct).join("") + "</div>";
      }
      if (data.collections.length) {
        html += '<div class="srch-mhead"><span class="srch-mlabel">Collections</span></div>' +
          '<div class="srch-links">' + data.collections.map(function (c) { return linkCard(c.url, c.title); }).join("") + "</div>";
      }
      if (data.pages.length) {
        html += '<div class="srch-mhead"><span class="srch-mlabel">Pages</span></div>' +
          '<div class="srch-links">' + data.pages.map(function (c) { return linkCard(c.url, c.title); }).join("") + "</div>";
      }
      main.innerHTML = html;
      collectItems();
    }
    function renderNone(q) {
      var wa = "https://wa.me/919717175338?text=" +
        encodeURIComponent("Hello ARGMAC, I'm looking for: " + q + ". Can you help?");
      main.innerHTML = '<div class="srch-none">' +
        '<p class="srch-none-t">Nothing found for “' + esc(q) + '”</p>' +
        '<p class="srch-none-sub">We craft bespoke and source rare pieces — tell us what you have in mind and our concierge will help.</p>' +
        '<a class="srch-wa" href="' + wa + '" target="_blank" rel="noopener">Enquire on WhatsApp</a>' +
        "</div>";
      collectItems();
    }

    /* ---- typo correction vocab (from products-index; RESULTS still come only from the API) ---- */
    var VOCAB = [], VOCABSET = {};
    (function () {
      (window.ARGMAC_INDEX || []).forEach(function (p) {
        (String(p.t || "") + " " + String(p.c || "")).toLowerCase().split(/[^a-z]+/).forEach(function (w) {
          if (w.length >= 4 && !VOCABSET[w]) { VOCABSET[w] = 1; VOCAB.push(w); }
        });
      });
    })();
    function lev(a, b, max) {
      if (Math.abs(a.length - b.length) > max) return max + 1;
      var prev = [], cur = [], i, j;
      for (j = 0; j <= b.length; j++) prev[j] = j;
      for (i = 1; i <= a.length; i++) {
        cur[0] = i; var best = i;
        for (j = 1; j <= b.length; j++) {
          var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
          cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
          if (cur[j] < best) best = cur[j];
        }
        if (best > max) return max + 1;
        for (j = 0; j <= b.length; j++) prev[j] = cur[j];
      }
      return prev[b.length];
    }
    function correctQuery(q) {
      if (!VOCAB.length) return null;
      var words = q.split(/\s+/).filter(Boolean), changed = false;
      var fixed = words.map(function (w) {
        if (w.length < 4 || VOCABSET[w]) return w;
        var thr = w.length <= 5 ? 1 : 2, best = null, bd = thr + 1;
        for (var i = 0; i < VOCAB.length; i++) {
          var d = lev(w, VOCAB[i], thr);
          if (d < bd) { bd = d; best = VOCAB[i]; if (d === 1) break; }
        }
        if (best && bd <= thr && best !== w) { changed = true; return best; }
        return w;
      });
      return changed ? fixed.join(" ") : null;
    }
    function hasResults(d) { return !!(d && (d.products.length + d.collections.length + d.pages.length) > 0); }
    function buildFallbacks(apiQ) {
      var list = [], words = apiQ.split(/\s+/).filter(Boolean);
      var longest = words.slice().sort(function (a, b) { return b.length - a.length; })[0];
      if (longest && longest.length >= 3 && longest !== apiQ) list.push({ q: longest, note: "Closest matches for “" + rawQuery + "”" });
      var corr = correctQuery(apiQ);
      if (corr && corr !== apiQ) list.push({ q: corr, note: "Showing results for “" + corr + "”" });
      return list;
    }
    function tryFallbacks(my, list, i) {
      if (my !== reqSeq) return;
      if (i >= list.length) { renderNone(rawQuery); return; }
      fetchSuggest(list[i].q, 8, function (d) {
        if (my !== reqSeq) return;
        if (hasResults(d)) renderResults(d, list[i].note);
        else tryFallbacks(my, list, i + 1);
      });
    }
    function detectMaterial(raw) {
      var s = " " + raw.toLowerCase().replace(/\s+/g, " ").trim() + " ";
      for (var i = 0; i < MAT_PHRASES.length; i++) {
        var ph = MAT_PHRASES[i];
        if (s.indexOf(" " + ph + " ") !== -1) {
          var canon = MAT_SYN[ph];
          return { canon: canon, display: MAT_DISPLAY[canon] || titleCase(canon) };
        }
      }
      return null;
    }
    function customIn(mat, cat) {
      var list = CAT_CUSTOM[cat] || [];
      if (list.indexOf(mat) !== -1) return true;
      if (WOOD_SUB[mat] && (list.indexOf("veneer") !== -1 || list.indexOf("wood") !== -1)) return true;
      if (mat === "ebony" && list.indexOf("wood") !== -1) return true;
      return false;
    }
    function cardFromIndex(p) { return { url: "/products/" + p.h, image: p.i, title: p.t, type: p.c, price: p.p }; }
    function renderMaterial(m) {
      var idx = window.ARGMAC_INDEX || [];
      var made = [], custom = [];
      idx.forEach(function (p) {
        if ((MADE[p.h] || []).indexOf(m.canon) !== -1) { made.push(p); return; }
        if (customIn(m.canon, p.c)) custom.push(p);
      });
      if (!made.length && !custom.length) { renderNone(rawQuery); return; }
      var html = "";
      if (made.length) {
        html += '<div class="srch-mhead"><span class="srch-mlabel">Made in ' + esc(m.display) + '</span></div>' +
          '<div class="srch-cards">' + made.slice(0, 12).map(cardFromIndex).map(cardProduct).join("") + "</div>";
      }
      if (custom.length) {
        html += '<div class="srch-mhead"><span class="srch-mlabel">Customisable in ' + esc(m.display) + '</span></div>' +
          '<div class="srch-cards">' + custom.slice(0, 12).map(cardFromIndex).map(cardProduct).join("") + "</div>";
      }
      main.innerHTML = html;
      collectItems();
    }
    function runSearch(raw) {
      var my = ++reqSeq;
      rawQuery = raw.trim();
      var mat = detectMaterial(raw);
      if (mat) { renderMaterial(mat); return; }
      var norm = normalize(raw);
      var col = extractColour(norm);
      colourNote = col.note;
      var apiQ = col.stripped || norm;
      fetchSuggest(apiQ, 8, function (data) {
        if (my !== reqSeq) return;
        if (hasResults(data)) { renderResults(data); return; }
        tryFallbacks(my, buildFallbacks(apiQ), 0);
      });
    }

    /* ---- keyboard / focus ---- */
    function collectItems() {
      items = Array.prototype.slice.call(
        ov.querySelectorAll(".srch-tlink, .srch-recentlink, .srch-navlink, .srch-card, .srch-viewall, .srch-link, .srch-wa"));
      if (hi >= 0) hi = -1;
    }
    function setHi(n) {
      if (hi >= 0 && items[hi]) items[hi].classList.remove("srch-hi");
      hi = n < 0 ? -1 : (n >= items.length ? items.length - 1 : n);
      if (hi >= 0 && items[hi]) { items[hi].classList.add("srch-hi"); items[hi].scrollIntoView({ block: "nearest" }); }
    }
    function isSeed(el) { return el.classList.contains("srch-tlink") || el.classList.contains("srch-recentlink"); }
    function activate(el) {
      if (isSeed(el)) { input.value = el.getAttribute("data-q") || ""; input.focus(); runSearch(input.value); return; }
      if (input.value.trim().length >= 2) recordRecent(input.value.trim());
      el.click();
    }
    function trapTab(e) {
      var f = Array.prototype.slice.call(
        ov.querySelectorAll('a[href],button,input,[tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function recordRecent(q) {
      q = (q || "").trim(); if (q.length < 2) return;
      var arr = (load(RECENT_KEY) || []).filter(function (x) { return String(x).toLowerCase() !== q.toLowerCase(); });
      arr.unshift(q);
      save(RECENT_KEY, arr.slice(0, 5));
    }

    function open() {
      ov.classList.add("open");
      document.body.style.overflow = "hidden";
      setTimeout(function () { input.focus(); }, 80);
      if (!input.value.trim()) showEmpty();
    }
    function close() { ov.classList.remove("open"); document.body.style.overflow = ""; }

    /* ---- wiring ---- */
    fillTrending();
    triggers.forEach(function (t) { t.addEventListener("click", function (e) { e.preventDefault(); open(); }); });
    ov.querySelector(".srch-close").addEventListener("click", close);
    input.addEventListener("input", function () {
      var v = input.value;
      clearTimeout(debT);
      hi = -1;
      if (!v.trim()) { showEmpty(); return; }
      debT = setTimeout(function () { runSearch(v); }, 200);
    });
    ov.addEventListener("click", function (e) {
      var seed = e.target.closest(".srch-tlink, .srch-recentlink");
      if (seed) { e.preventDefault(); input.value = seed.getAttribute("data-q") || ""; input.focus(); runSearch(input.value); return; }
      var nav = e.target.closest(".srch-card, .srch-viewall, .srch-link, .srch-navlink");
      if (nav && input.value.trim().length >= 2) recordRecent(input.value.trim());
    });
    ov.addEventListener("keydown", function (e) {
      if (!ov.classList.contains("open")) return;
      if (e.key === "ArrowDown") { e.preventDefault(); setHi(hi + 1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); if (hi <= 0) { setHi(-1); input.focus(); } else setHi(hi - 1); }
      else if (e.key === "Enter") {
        if (hi >= 0 && items[hi]) { e.preventDefault(); activate(items[hi]); }
        else if (input.value.trim()) { e.preventDefault(); recordRecent(input.value.trim()); window.location.href = "/search?q=" + encodeURIComponent(input.value.trim()); }
      }
      else if (e.key === "Escape") { close(); }
      else if (e.key === "Tab") { trapTab(e); }
    });
  }

  /* ---------------- RESPONSIVE IMAGES (Shopify CDN) ---------------- */
  function applySrcset(img) {
    var u = img.getAttribute("src");
    if (!u || u.indexOf("cdn.shopify.com") === -1) { img.removeAttribute("srcset"); return; }
    var sep = u.indexOf("?") === -1 ? "?" : "&";
    img.srcset = u + sep + "width=480 480w, " + u + sep + "width=900 900w, " + u + sep + "width=1400 1400w";
    var inCard = img.closest(".card-img, .rv-img, .sc-img, .wi-img, .co-img");
    img.sizes = inCard ? "(max-width: 560px) 72vw, (max-width: 1020px) 50vw, 25vw"
                       : "(max-width: 1020px) 92vw, 60vw";
    img.decoding = "async";
  }
  function srcsetify() {
    document.querySelectorAll('img[src*="cdn.shopify.com"]').forEach(function (img) {
      if (img.srcset) return;
      applySrcset(img);
    });
    // Keep the main swappable gallery image's srcset in sync with its src,
    // otherwise srcset would override the colour-swatch image swap.
    var main = document.getElementById("mainImg");
    if (main && "MutationObserver" in window) {
      new MutationObserver(function () { applySrcset(main); })
        .observe(main, { attributes: true, attributeFilter: ["src"] });
    }
  }

  /* ---------------- MOBILE EXTRAS ---------------- */
  function buildMobileExtras() {
    // sticky buy bar on product pages
    var b = document.body;
    if (b.dataset.handle) {
      var bar = document.createElement("div");
      bar.className = "m-bar";
      bar.innerHTML =
        '<div class="mb-info"><div class="mb-title">' + b.dataset.title + '</div>' +
        '<div class="mb-price">' + b.dataset.price + "</div></div>" +
        '<button class="mb-add" type="button" aria-label="Add to Cart">Add</button>' +
        '<a class="mb-wa wa-enquire" href="https://wa.me/919717175338" target="_blank" rel="noopener">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.2 14.2c-.2.6-1.2 1.2-1.7 1.2-.4.1-1 .1-1.6-.1-.4-.1-.9-.3-1.5-.6-2.6-1.1-4.3-3.8-4.4-4-.1-.2-1-1.4-1-2.6 0-1.2.6-1.8.9-2 .2-.3.5-.3.7-.3h.5c.2 0 .4-.1.6.4l.9 2.1c.1.2.1.4 0 .6l-.4.6-.5.5c-.1.2-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1.1 2.2 1.4 2.5 1.5.3.2.5.1.7-.1l1-1.2c.2-.3.4-.2.7-.1l2 1c.3.1.5.2.6.3.1.2.1.7-.1 1.2z"/></svg>' +
        'Enquire</a>';
      document.body.appendChild(bar);
      bar.querySelector(".mb-add").addEventListener("click", function () {
        var p = document.querySelector(".actions .js-add-cart");
        if (p) p.click();
      });
      // sync the m-bar WhatsApp link with the current variant selection
      if (window.__waUpd) window.__waUpd();
    }
    // utility row inside mobile nav: search / cart
    var nav = document.getElementById("mobileNav");
    if (nav && !nav.querySelector(".mn-util")) {
      var util = document.createElement("div");
      util.className = "mn-util";
      util.innerHTML =
        '<button class="hlink search-open" type="button">Search</button>' +
        '<button class="hlink cart-open" type="button">Cart</button>';
      var mc = nav.querySelector(".mn-contact");
      if (mc) nav.insertBefore(util, mc); else nav.appendChild(util);
      util.querySelectorAll("button").forEach(function (btn) {
        btn.addEventListener("click", function () { nav.classList.remove("open"); });
      });
    }
    document.querySelectorAll(".cart-open").forEach(function (btn) {
      btn.addEventListener("click", function () { if (cartUI.open) cartUI.open(); });
    });
    // browser chrome colour
    if (!document.querySelector('meta[name="theme-color"]')) {
      var m = document.createElement("meta");
      m.name = "theme-color"; m.content = "#161412";
      document.head.appendChild(m);
    }
  }

  /* ---------------- STORAGE HELPERS ---------------- */
  function load(k) { try { return JSON.parse(localStorage.getItem(k)) || []; } catch (e) { return []; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function pageProduct() {
    var b = document.body;
    if (!b.dataset.handle) return null;
    return { h: b.dataset.handle, t: b.dataset.title, p: b.dataset.price, i: b.dataset.img };
  }
  function inr(n) {
    var s = String(Math.round(n)), out;
    if (s.length <= 3) return "₹" + s;
    out = s.slice(-3); s = s.slice(0, -3);
    while (s.length > 2) { out = s.slice(-2) + "," + out; s = s.slice(0, -2); }
    return "₹" + s + "," + out;
  }

  /* ---------------- CART ---------------- */
  var CART_KEY = "argmac_cart";
  var cartUI = {};
  function cartCount() { return load(CART_KEY).reduce(function (n, it) { return n + it.q; }, 0); }

  function buildCart() {
    var right = document.querySelector(".header .h-side.right");
    var headLink = document.createElement("a");
    headLink.className = "wish-head cart-head";
    function headRender() {
      var n = cartCount();
      headLink.innerHTML = "Cart" + (n ? '<span class="wish-count">' + n + "</span>" : "");
    }
    if (right) { right.appendChild(headLink); headRender(); }

    var veil = document.createElement("div"); veil.className = "wish-veil cart-veil";
    var drawer = document.createElement("aside"); drawer.className = "wish-drawer cart-drawer";
    drawer.innerHTML =
      '<div class="wish-top"><h3>Your Cart</h3><button aria-label="Close">&times;</button></div>' +
      '<div class="wish-items cart-items"></div>' +
      '<div class="cart-foot"></div>';
    document.body.appendChild(veil); document.body.appendChild(drawer);
    var itemsEl = drawer.querySelector(".cart-items"), footEl = drawer.querySelector(".cart-foot");

    function totals() {
      var sub = load(CART_KEY).reduce(function (s, it) { return s + it.p * it.q; }, 0);
      return { sub: sub, gst: sub * 0.18, total: sub * 1.18 };
    }
    function render() {
      var items = load(CART_KEY);
      if (!items.length) {
        itemsEl.innerHTML = '<div class="wish-empty"><span class="we-heart">◇</span>Your cart is empty.<br>Every piece is made to order.</div>';
        footEl.innerHTML = "";
        headRender();
        return;
      }
      itemsEl.innerHTML = items.map(function (it, i) {
        return '<div class="wish-item">' +
          '<a class="wi-img" href="' + ROOT + "/products/" + it.h + '"><img src="' + it.i + '" alt="' + it.t + '"></a>' +
          '<div><h4><a href="' + ROOT + "/products/" + it.h + '">' + it.t + "</a></h4>" +
          (it.v ? '<div class="wi-variant">' + it.v + "</div>" : "") +
          '<div class="wi-price">' + inr(it.p) + "</div>" +
          '<div class="qty"><button data-i="' + i + '" data-d="-1">−</button><span>' + it.q + '</span><button data-i="' + i + '" data-d="1">+</button></div></div>' +
          '<button class="wi-rm" data-i="' + i + '" aria-label="Remove">&times;</button></div>';
      }).join("");
      var t = totals();
      footEl.innerHTML = isIntl() ?
        '<div class="cart-row total"><span>Total</span><b>' + inr(t.sub) + "</b></div>" + INTL_NOTE +
        '<a class="btn primary cart-co" href="' + ROOT + '/pages/checkout">Proceed to Checkout</a>' :
        '<div class="cart-row"><span>Subtotal (excl. GST)</span><b>' + inr(t.sub) + "</b></div>" +
        '<div class="cart-row"><span>GST (18%)</span><b>' + inr(t.gst) + "</b></div>" +
        '<div class="cart-row total"><span>Total</span><b>' + inr(t.total) + "</b></div>" +
        '<div class="cart-perk">' + (t.sub >= 1000000
          ? "✦ Complimentary on-site design visit included with this order."
          : "White-glove delivery &amp; installation included.") + "</div>" +
        '<div class="pin-check"><input type="text" maxlength="6" inputmode="numeric" placeholder="Delivery pincode" aria-label="Pincode">' +
        '<button type="button">Check</button></div><div class="pin-result"></div>' +
        '<a class="btn primary cart-co" href="' + ROOT + '/pages/checkout">Proceed to Checkout</a>';
      itemsEl.querySelectorAll(".qty button").forEach(function (b) {
        b.addEventListener("click", function () {
          var items2 = load(CART_KEY), i = +b.dataset.i;
          items2[i].q = Math.max(1, items2[i].q + (+b.dataset.d));
          save(CART_KEY, items2); render(); headRender();
        });
      });
      itemsEl.querySelectorAll(".wi-rm").forEach(function (b) {
        b.addEventListener("click", function () {
          var items2 = load(CART_KEY); items2.splice(+b.dataset.i, 1);
          save(CART_KEY, items2); render(); headRender();
        });
      });
      var pin = footEl.querySelector(".pin-check input"), res = footEl.querySelector(".pin-result");
      if (pin) footEl.querySelector(".pin-check button").addEventListener("click", function () {
        if (/^[1-9][0-9]{5}$/.test(pin.value.trim())) {
          res.innerHTML = "✓ Deliverable to " + pin.value.trim() + " — made to order, typically 6–8 weeks, installed by our team.";
          res.className = "pin-result ok";
        } else {
          res.textContent = "Please enter a valid 6-digit pincode.";
          res.className = "pin-result err";
        }
      });
    }
    function openDrawer() { render(); drawer.classList.add("open"); veil.classList.add("open"); }
    function closeDrawer() { drawer.classList.remove("open"); veil.classList.remove("open"); }
    headLink.addEventListener("click", openDrawer);
    veil.addEventListener("click", closeDrawer);
    drawer.querySelector(".wish-top button").addEventListener("click", closeDrawer);
    cartUI.open = openDrawer; cartUI.headRender = headRender;

    // wire PDP Add to Cart
    var prod = pageProduct();
    var addBtn = document.querySelector(".actions .js-add-cart");
    if (prod && addBtn && addBtn.tagName === "BUTTON") {
      addBtn.addEventListener("click", function () {
        var priceEl = document.getElementById("price");
        // data-cents holds the INR price even when the label shows AED/AUD (snippets/market-currency.liquid)
        var num = priceEl && priceEl.dataset.cents ? Math.round(parseInt(priceEl.dataset.cents, 10) / 100) : (priceEl ? parseInt((priceEl.childNodes[0].textContent || "").replace(/[^\d]/g, ""), 10) : 0);
        if (!num) num = parseInt((prod.p || "").replace(/[^\d]/g, ""), 10) || 0;
        var vEl = document.getElementById("vName");
        var variant = vEl ? vEl.textContent : "";
        var items = load(CART_KEY);
        var found = items.find(function (x) { return x.h === prod.h && x.v === variant; });
        if (found) found.q += 1;
        else items.unshift({ h: prod.h, t: prod.t, i: prod.i, p: num, v: variant, q: 1 });
        save(CART_KEY, items);
        openDrawer();
      });
    }
  }

  /* ---------------- LIGHTBOX ZOOM ---------------- */
  function buildLightbox() {
    var imgs = [].slice.call(document.querySelectorAll(".gallery .g-img img"));
    if (!imgs.length) return;
    var lb = document.createElement("div");
    lb.className = "lb";
    lb.innerHTML =
      '<button class="lb-close" aria-label="Close">&times;</button>' +
      '<div class="lb-hint">Click image to magnify</div>' +
      '<button class="lb-btn lb-prev" aria-label="Previous">&#8592;</button>' +
      '<div class="lb-img-wrap"><img alt="Zoom view"></div>' +
      '<button class="lb-btn lb-next" aria-label="Next">&#8594;</button>' +
      '<div class="lb-count"></div>';
    document.body.appendChild(lb);
    var wrap = lb.querySelector(".lb-img-wrap"), im = wrap.querySelector("img"),
        count = lb.querySelector(".lb-count"), idx = 0;
    function render() {
      im.src = imgs[idx].src; im.style.transform = "";
      wrap.classList.remove("zoomed");
      count.textContent = (idx + 1) + " / " + imgs.length;
    }
    function open(i) { idx = i; render(); lb.classList.add("open"); document.body.style.overflow = "hidden"; }
    function close() { lb.classList.remove("open"); document.body.style.overflow = ""; }
    imgs.forEach(function (img, i) {
      img.closest(".g-img").addEventListener("click", function () { open(i); });
    });
    lb.querySelector(".lb-close").addEventListener("click", close);
    lb.addEventListener("click", function (e) { if (e.target === lb) close(); });
    lb.querySelector(".lb-prev").addEventListener("click", function () { idx = (idx - 1 + imgs.length) % imgs.length; render(); });
    lb.querySelector(".lb-next").addEventListener("click", function () { idx = (idx + 1) % imgs.length; render(); });
    im.addEventListener("click", function (e) {
      if (wrap.classList.contains("zoomed")) { im.style.transform = ""; wrap.classList.remove("zoomed"); return; }
      var r = im.getBoundingClientRect();
      var ox = ((e.clientX - r.left) / r.width) * 100, oy = ((e.clientY - r.top) / r.height) * 100;
      im.style.transformOrigin = ox + "% " + oy + "%";
      im.style.transform = "scale(2.2)";
      wrap.classList.add("zoomed");
    });
    document.addEventListener("keydown", function (e) {
      if (!lb.classList.contains("open")) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") { idx = (idx - 1 + imgs.length) % imgs.length; render(); }
      if (e.key === "ArrowRight") { idx = (idx + 1) % imgs.length; render(); }
    });
    // touch swipe
    var tx = null, ty = null;
    lb.addEventListener("touchstart", function (e) {
      tx = e.touches[0].clientX; ty = e.touches[0].clientY;
    }, { passive: true });
    lb.addEventListener("touchend", function (e) {
      if (tx === null || wrap.classList.contains("zoomed")) return;
      var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        idx = (idx + (dx < 0 ? 1 : -1) + imgs.length) % imgs.length; render();
      } else if (dy > 90 && Math.abs(dy) > Math.abs(dx) * 1.4) {
        close();
      }
      tx = ty = null;
    }, { passive: true });
  }

  /* ---------------- RECENTLY VIEWED ---------------- */
  function buildRecent() {
    var KEY = "argmac_recent";
    var prod = pageProduct();
    var items = load(KEY);
    if (prod) {
      items = items.filter(function (x) { return x.h !== prod.h; });
      items.unshift(prod);
      save(KEY, items.slice(0, 12));
      items = load(KEY).filter(function (x) { return x.h !== prod.h; });
    }
    if (!items.length) return;
    var footer = document.querySelector("footer");
    if (!footer) return;
    var sec = document.createElement("section");
    sec.className = "recent";
    sec.innerHTML =
      '<div class="rv-head"><div class="rv-kicker">Your Trail</div><h2>Recently Viewed</h2></div>' +
      '<div class="rv-grid">' + items.slice(0, 6).map(function (it) {
        return '<a class="rv-card" href="' + ROOT + "/products/" + it.h + '">' +
          '<div class="rv-img"><img loading="lazy" src="' + it.i + '" alt="' + it.t + '"></div>' +
          "<h4>" + it.t + "</h4><span>" + it.p + "</span></a>";
      }).join("") + "</div>";
    footer.parentNode.insertBefore(sec, footer);
  }

  /* ---------------- CONCIERGE ---------------- */
  function buildConcierge() {
    var c = document.createElement("div");
    c.className = "concierge";
    c.innerHTML =
      '<div class="cg-menu">' +
      '<a href="https://wa.me/919717175338" target="_blank" rel="noopener">WhatsApp Us</a>' +
      '<a href="tel:+919717175338">Call +91 97171 75338</a>' +
      '<a href="' + ROOT + '/pages/consultation">Book a Consultation</a>' +
      "</div>" +
      '<button class="cg-pill" type="button"><span class="cg-dot"></span>Consult Us</button>';
    document.body.appendChild(c);
    c.querySelector(".cg-pill").addEventListener("click", function () { c.classList.toggle("open"); });
    document.addEventListener("click", function (e) { if (!c.contains(e.target)) c.classList.remove("open"); });
  }

  /* ---------------- WILL IT FIT ---------------- */
  var FIT = {
    pool: {
      title: "Will it fit? — Pool Table",
      intro: "A pool table needs space for a full cue swing on every side. The rule: room length and width should equal the playing field plus two cue lengths.",
      table: [
        ["9' table (playing field 8' × 4')", "58\" cue", "≈ 17'10\" × 13'10\""],
        ["9' table (playing field 8' × 4')", "52\" cue", "≈ 16'10\" × 12'10\""],
        ["9' table (playing field 8' × 4')", "48\" cue (compact)", "≈ 16'2\" × 12'2\""]
      ],
      tdims: "9' × 5'"
    },
    snooker: {
      title: "Will it fit? — Snooker Table",
      intro: "Full-size snooker demands generous clearance for the long cue. Our design team will confirm fit for your room with a site visit.",
      table: [
        ["12' full-size table", "58\" cue", "≈ 22' × 16'"],
        ["10' table", "58\" cue", "≈ 20' × 15'"],
        ["10' table", "48\" cue (compact)", "≈ 18'4\" × 13'4\""]
      ],
      tdims: "12' × 6'"
    },
    tt: {
      title: "Will it fit? — Table Tennis",
      intro: "Table tennis needs run-back room behind each end and side clearance for rallies.",
      table: [
        ["8' × 4' table", "Recreational play", "≈ 19' × 11'"],
        ["8' × 4' table", "Club-level play", "≈ 28' × 13'"],
        ["8' × 4' table", "Casual / kids", "≈ 17' × 10'"]
      ],
      tdims: "8' × 4'"
    },
    airhockey: {
      title: "Will it fit? — Air Hockey",
      intro: "Air hockey needs elbow room at both ends and comfortable passage along the sides.",
      table: [
        ["8' × 4' table", "Comfortable play", "≈ 14' × 10'"],
        ["8' × 4' table", "Minimum", "≈ 12' × 8'"]
      ],
      tdims: "8' × 4'"
    },
    carrom: {
      title: "Will it fit? — Carrom Table",
      intro: "Carrom is played seated on all four sides — allow chair space around the board.",
      table: [
        ["Standard carrom table", "Seated play, four sides", "≈ 10' × 10'"],
        ["Standard carrom table", "Two-player", "≈ 9' × 7'"]
      ],
      tdims: "3' × 3'"
    }
  };

  function fitSVG(tdims) {
    return '<svg viewBox="0 0 600 340" xmlns="http://www.w3.org/2000/svg" font-family="Jost,sans-serif">' +
      '<rect x="20" y="20" width="560" height="300" fill="none" stroke="#a8895a" stroke-width="1.5" stroke-dasharray="7 6"/>' +
      '<text x="300" y="14" text-anchor="middle" font-size="11" letter-spacing="3" fill="#a8895a">RECOMMENDED ROOM</text>' +
      '<rect x="170" y="105" width="260" height="130" fill="#efe9e0" stroke="#161412" stroke-width="1.5"/>' +
      '<text x="300" y="175" text-anchor="middle" font-size="13" letter-spacing="2" fill="#161412">TABLE ' + tdims + "</text>" +
      '<line x1="30" y1="170" x2="166" y2="170" stroke="#3c3833" stroke-width="1"/>' +
      '<line x1="434" y1="170" x2="570" y2="170" stroke="#3c3833" stroke-width="1"/>' +
      '<text x="98" y="160" text-anchor="middle" font-size="10.5" letter-spacing="1.5" fill="#3c3833">CUE / PLAY CLEARANCE</text>' +
      '<text x="502" y="160" text-anchor="middle" font-size="10.5" letter-spacing="1.5" fill="#3c3833">CUE / PLAY CLEARANCE</text>' +
      '<line x1="300" y1="30" x2="300" y2="100" stroke="#3c3833" stroke-width="1"/>' +
      '<line x1="300" y1="240" x2="300" y2="310" stroke="#3c3833" stroke-width="1"/>' +
      "</svg>";
  }

  function buildFit() {
    var trigger = document.querySelector(".fit-link");
    if (!trigger) return;
    var d = FIT[trigger.dataset.fit];
    if (!d) return;
    var modal = document.createElement("div");
    modal.className = "fit-modal";
    modal.innerHTML =
      '<div class="fit-card"><button class="fm-close" aria-label="Close">&times;</button>' +
      '<div class="fm-kicker">Room Planning</div><h3>' + d.title + "</h3><p>" + d.intro + "</p>" +
      '<div class="fit-diagram">' + fitSVG(d.tdims) + "</div>" +
      '<table class="fit-table"><tr><th>Table</th><th>Play style</th><th>Recommended room</th></tr>' +
      d.table.map(function (r) { return "<tr><td>" + r[0] + "</td><td>" + r[1] + "</td><td><b>" + r[2] + "</b></td></tr>"; }).join("") +
      "</table>" +
      '<div class="fit-note">Unsure about your space? Our design team confirms fit with a complimentary consultation — measurements, layout and lighting included.</div></div>';
    document.body.appendChild(modal);
    trigger.addEventListener("click", function () { modal.classList.add("open"); document.body.style.overflow = "hidden"; });
    function close() { modal.classList.remove("open"); document.body.style.overflow = ""; }
    modal.querySelector(".fm-close").addEventListener("click", close);
    modal.addEventListener("click", function (e) { if (e.target === modal) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  /* ---------------- CHECKOUT PAGE ---------------- */
  function buildCheckout() {
    var box = document.getElementById("checkoutSummary");
    if (!box) return;
    var items = load(CART_KEY);
    if (!items.length) {
      box.innerHTML = '<div class="wish-empty"><span class="we-heart">◇</span>Your cart is empty.<br><a href="' + ROOT + '/collections/bestsellers" style="text-decoration:underline">Explore the bestsellers</a></div>';
      var act = document.getElementById("checkoutActions");
      if (act) act.style.display = "none";
      return;
    }
    var sub = items.reduce(function (s, it) { return s + it.p * it.q; }, 0);
    box.innerHTML = items.map(function (it) {
      return '<div class="co-item"><div class="co-img"><img src="' + it.i + '" alt=""></div>' +
        "<div><h4>" + it.t + "</h4>" + (it.v ? "<span>" + it.v + "</span>" : "") +
        "<span>Qty " + it.q + "</span></div><b>" + inr(it.p * it.q) + "</b></div>";
    }).join("") + (isIntl() ?
      '<div class="cart-row total"><span>Total</span><b>' + inr(sub) + "</b></div>" + INTL_NOTE :
      '<div class="cart-row"><span>Subtotal (excl. GST)</span><b>' + inr(sub) + "</b></div>" +
      '<div class="cart-row"><span>GST (18%)</span><b>' + inr(sub * 0.18) + "</b></div>" +
      '<div class="cart-row total"><span>Total</span><b>' + inr(sub * 1.18) + "</b></div>");
    var wa = document.getElementById("checkoutWA");
    if (wa) {
      var msg = "Hello ARGMAC, I would like to place this order:%0A" +
        items.map(function (it) { return "• " + it.t + (it.v ? " (" + it.v + ")" : "") + " × " + it.q + " — " + inr(it.p * it.q); }).join("%0A") +
        (isIntl() ? "%0ATotal (excl. taxes & duties): " + inr(sub) : "%0ATotal (incl. GST): " + inr(sub * 1.18));
      wa.href = "https://wa.me/919717175338?text=" + msg.replace(/₹/g, "Rs.");
    }
  }

  /* ---------------- CATALOGUE GATE ---------------- */
  function buildGate() {
    var gate = document.getElementById("catGate");
    if (!gate) return;
    var KEY = "argmac_catalogue_email";
    var reveal = document.getElementById("catReveal");
    function show() { gate.style.display = "none"; reveal.style.display = "block"; }
    if (localStorage.getItem(KEY)) show();
    gate.querySelector("button").addEventListener("click", function () {
      var em = gate.querySelector("input").value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) {
        gate.querySelector(".gate-err").textContent = "Please enter a valid email address.";
        return;
      }
      try { localStorage.setItem(KEY, em); } catch (e) {}
      show();
    });
  }

  /* ---------------- CONSULTATION NUDGE (PDP, once per session) ---------------- */
  function buildNudge() {
    var b = document.body;
    if (!b.dataset.handle) return;                       // product pages only
    var KEY = "argmac_nudge_shown";
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
    var engaged = false;                                  // any CTA tap cancels it
    document.addEventListener("click", function (e) {
      if (e.target.closest(".wa-enquire,.js-add-cart,.call-btn,.m-bar,.concierge")) engaged = true;
    });
    var name = (b.dataset.title || "this piece").replace(/ (Pool|Snooker|Tennis|Carrom|Chess|DJ|Foosball|Air Hockey).*$/i, "");
    var el = document.createElement("div");
    el.className = "nudge";
    el.innerHTML =
      '<button class="nudge-x" aria-label="Dismiss">&times;</button>' +
      '<p>Questions about the ' + name + "? Consult us \u2014 we reply in minutes.</p>" +
      '<a class="nudge-wa wa-enquire" href="https://wa.me/919717175338" target="_blank" rel="noopener">Ask on WhatsApp</a>';
    document.body.appendChild(el);
    function show() {
      if (engaged) return;
      try { sessionStorage.setItem(KEY, "1"); } catch (e) {}
      el.classList.add("on");
      if (window.__waUpd) window.__waUpd();
    }
    function dismiss() { el.classList.remove("on"); }
    el.querySelector(".nudge-x").addEventListener("click", dismiss);
    el.querySelector(".nudge-wa").addEventListener("click", dismiss);
    var fired = false;
    window.addEventListener("scroll", function () {
      if (fired) return;
      var d = document.documentElement;
      var depth = (window.scrollY + window.innerHeight) / d.scrollHeight;
      if (depth > 0.6) { fired = true; setTimeout(show, 900); }
    }, { passive: true });
  }

  /* ---------------- CONSULT US POPUP (every page, once per session) ----------------
     Opens 4 s after load with the same three routes as the Consult Us pill. Its
     WhatsApp link is a plain wa.me link, so the qualifier snippet intercepts it
     exactly like the pill: qualifier form -> argmac_qualified_contact -> Meta
     Contact + Lead + web_qualifier_leads row. Classes cp-wa / cp-call / cp-book /
     cp-x let site_events tell popup taps apart (intent_tap.element, click.element).
     Skipped when: already shown this session, the visitor already qualified, any
     CTA was tapped first, another modal is open, or on consultation/checkout/cart. */
  function buildConsultPopup() {
    var KEY = "argmac_consult_popup_v1";
    var DELAY = 4000;
    try {
      if (sessionStorage.getItem(KEY)) return;
      if (sessionStorage.getItem("argmac_qualifier_v1")) return;
    } catch (e) {}
    if (/\/(pages\/(consultation|checkout)|cart|account|checkouts)(\/|$)/.test(location.pathname)) return;
    var engaged = false;
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest(".wa-enquire,.js-add-cart,.call-btn,.m-bar,.concierge,.nudge,a[href^='tel:'],a[href*='wa.me']")) engaged = true;
    }, true);

    var el = document.createElement("div");
    el.className = "cpop";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    el.setAttribute("aria-labelledby", "cpopTitle");
    el.innerHTML =
      '<div class="cpop-card">' +
      '<button class="cp-x" type="button" aria-label="Close">&times;</button>' +
      '<div class="cpop-kicker">Private consultation</div>' +
      '<h3 id="cpopTitle">Consult Us</h3>' +
      "<p>Planning a pool table, home bar or game room? Tell us your space and budget — we reply on WhatsApp in minutes.</p>" +
      '<div class="cpop-actions">' +
      '<a class="cp-wa" href="https://wa.me/919717175338" target="_blank" rel="noopener">WhatsApp Us</a>' +
      '<a class="cp-call" href="tel:+919717175338">Call +91 97171 75338</a>' +
      "</div>" +
      '<a class="cp-book" href="' + ROOT + '/pages/consultation">Book a Consultation</a>' +
      "</div>";
    document.body.appendChild(el);

    var waits = 0;
    function busy() {
      // Cookie banners (Shopify's own + the Scala LGPD app): wait for them, max ~12 s
      var pc = document.getElementById("shopify-pc__banner");
      var cookieOpen = (pc && getComputedStyle(pc).display !== "none" && pc.offsetHeight > 0) || !!document.querySelector("scala-lgpd.mount");
      if (cookieOpen && waits < 8) { waits++; return true; }
      var q = document.querySelector(".argmac-q");
      if (q && getComputedStyle(q).display !== "none") return true;
      if (document.body.style.overflow === "hidden") return true;        // mobile nav, lightbox, fit modal lock the page
      return !!document.querySelector(".fit-modal.open,.lb.open,.srch.open,.wish-drawer.open,.cart-drawer.open");
    }
    function close() {
      el.classList.remove("on");
      document.removeEventListener("keydown", onKey);
    }
    function onKey(e) { if (e.key === "Escape") close(); }
    function show() {
      if (engaged) return;
      if (document.visibilityState !== "visible" || busy()) { setTimeout(show, 1500); return; }
      try {
        sessionStorage.setItem(KEY, "1");
        sessionStorage.setItem("argmac_nudge_shown", "1");   // one prompt per session, not two
      } catch (e) {}
      el.classList.add("on");
      document.addEventListener("keydown", onKey);
    }
    el.querySelector(".cp-x").addEventListener("click", close);
    el.addEventListener("click", function (e) {
      if (e.target === el || e.target.closest(".cp-wa,.cp-call,.cp-book")) close();
    });
    setTimeout(show, DELAY);
  }

  /* ---------------- INIT ---------------- */
  function init() {
    buildMega();
    buildMobileMega();
    buildSearch();
    buildLightbox();
    buildCart();
    buildRecent();
    buildConcierge();
    buildFit();
    buildCheckout();
    buildGate();
    buildMobileExtras();
    buildNudge();
    buildConsultPopup();
    srcsetify();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
